import objectFitImages from 'object-fit-images'
import smoothscroll from 'smoothscroll-polyfill'

// kick off the polyfill!
smoothscroll.polyfill()

jQuery(document).ready(function () {
    objectFitImages()
    jQuery('[data-toggle="tooltip"]').tooltip()
});

//IE forEach polyfill
if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window

        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this)
        }
    };
}

// Mobile vh fix
// We listen to the resize event
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
